export enum PublishActions {
    Publish = 1,
    Unpublish = 2
}